/*
All fetch functions here accept a callback. The callback will more than likely
end up being a setState call in the component it is called from.
*/

import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

/*
@NotEmpty // validated by @Valid annotation when passed as parameter
@JsonProperty("password")
private String password;
*/
const reset = (password, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/password/reset',
    headers,
    JSON.stringify(password),
    successCallback,
    errorCallback,
  );
};

const checkResetToken = (patientUuid, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
      '/api/password/check-reset-token',
      headers,
      JSON.stringify(patientUuid),
      successCallback,
      errorCallback,
  );
};

/*
@JsonProperty("username")
private String username;
*/
const forgot = (username, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    'api/public/forgot-password',
    headers,
    JSON.stringify(username),
    successCallback,
    errorCallback,
  );
};



const PasswordApi = { reset, forgot, checkResetToken };

export default PasswordApi;



// WEBPACK FOOTER //
// ./src/apis/password.js